<template>
  <div class="h-full flex flex-col bg-white rounded-t-3xl p-6">
    <!-- Header shimmer -->
    <div class="flex items-center justify-between mb-6">
      <div class="h-6 w-32 bg-gray-200 rounded shimmer"></div>
      <div class="h-8 w-8 bg-gray-200 rounded-full shimmer"></div>
    </div>

    <!-- Items shimmer -->
    <div class="flex-1 space-y-4">
      <div v-for="i in 3" :key="i" class="flex gap-4">
        <div class="w-20 h-20 bg-gray-200 rounded-2xl shimmer"></div>
        <div class="flex-1 space-y-2">
          <div class="h-4 w-3/4 bg-gray-200 rounded shimmer"></div>
          <div class="h-3 w-1/2 bg-gray-200 rounded shimmer"></div>
          <div class="h-4 w-1/3 bg-gray-200 rounded shimmer"></div>
        </div>
      </div>
    </div>

    <!-- Summary shimmer -->
    <div class="space-y-3 mt-6">
      <div class="flex justify-between">
        <div class="h-4 w-24 bg-gray-200 rounded shimmer"></div>
        <div class="h-4 w-16 bg-gray-200 rounded shimmer"></div>
      </div>
      <div class="flex justify-between">
        <div class="h-4 w-24 bg-gray-200 rounded shimmer"></div>
        <div class="h-4 w-16 bg-gray-200 rounded shimmer"></div>
      </div>
      <div class="h-px bg-gray-200 my-4"></div>
      <div class="flex justify-between">
        <div class="h-6 w-20 bg-gray-200 rounded shimmer"></div>
        <div class="h-6 w-20 bg-gray-200 rounded shimmer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.shimmer {
  animation: shimmer 2s infinite;
  background: linear-gradient(
    to right,
    #f3f4f6 0%,
    #e5e7eb 20%,
    #f3f4f6 40%,
    #f3f4f6 100%
  );
  background-size: 1000px 100%;
}
</style>
